// https://nuxt.com/docs/examples/advanced/error-handling
// Custom error handler plugin

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook("app:error", (error) => {
        console.log('app:error', error)
        const reload_error_list = [
            "error loading dynamically imported module",
            "Importing a module script failed",
            "Failed to fetch dynamically imported module",
        ];
        for (const message of reload_error_list) {
            if (error.message.indexOf(message) > -1) {
                const lastForcedReload = sessionStorage.getItem('lastForcedReload')
                const now = Date.now()

                if (!lastForcedReload || now - parseInt(lastForcedReload) > 60000) {
                    sessionStorage.setItem('lastForcedReload', now.toString())
                    console.warn('Chunk fetch error detected, forcing reload')
                    window.location.reload()
                } else {
                    console.warn('Reload loop detected, skipping reload')
                }
            }
        }
    });

    nuxtApp.hook('vue:error', (error, instance, info) => {
        console.log('vue:error', error)
        // if (process.client) {
        //   handle client side
        // }
    })

    // Global error handler
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        console.log('global error handler', error)
        // if (process.client) {
        //   handle client side
        // }
    }
});
